var i = Object.defineProperty, f = Object.defineProperties;
var n = Object.getOwnPropertyDescriptors;
var r = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable;
var p = (o, e, m) => e in o ? i(o, e, { enumerable: !0, configurable: !0, writable: !0, value: m }) : o[e] = m, t = (o, e) => {
  for (var m in e || (e = {}))
    c.call(e, m) && p(o, m, e[m]);
  if (r)
    for (var m of r(e))
      l.call(e, m) && p(o, m, e[m]);
  return o;
}, a = (o, e) => f(o, n(e));
import s, { forwardRef as g } from "react";
import h from "../lib/IconBase.mjs";
import d from "../defs/MegaphoneSimple.mjs";
const w = g((o, e) => /* @__PURE__ */ s.createElement(h, a(t({ ref: e }, o), { weights: d })));
w.displayName = "MegaphoneSimple";
export {
  w as MegaphoneSimple
};
